module.exports = __webpack_public_path__ + "img/htit1.4396c9ee.png";